import { createSlice } from "@reduxjs/toolkit";
import { trackAddToCart } from "../analytics/track";

const storeInLocalStorage = (data) => {
  localStorage.setItem("cart", JSON.stringify(data));
};

/**
 * The cart was being written to localStorage but never read back — initialState
 * was hardcoded to [], so any customer who closed the tab lost their basket.
 */
const loadCartFromLocalStorage = () => {
  try {
    const raw = localStorage.getItem("cart");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.error("Stored cart could not be read", err);
    return [];
  }
};

const restoredCart = loadCartFromLocalStorage();

const sumTotals = (items) => ({
  totalItems: items.length,
  totalAmounts: items.reduce((total, item) => total + (item.totalPrice || 0), 0),
});
const storeTokenInLocalStorage = (data) => {
  localStorage.setItem("token", JSON.stringify(data));
};

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    data: restoredCart,
    ...sumTotals(restoredCart),
    deliveryCharge: 0,
  },
  reducers: {
    addToCart(state, action) {
      const existingItem = state.data.find(
        (item) => item.id === action.payload.id
      );

      if (existingItem) {
        const tempCart = state.data.map((item) => {
          if (item.id === action.payload.id) {
            let newQty = item.quantity + action.payload.quantity;
            let newTotalPrice = newQty * item.price;
            return {
              ...item,
              quantity: newQty,
              totalPrice: newTotalPrice,
            };
          } else {
            return item;
          }
        });
        state.data = tempCart;
        storeInLocalStorage(state.data);
      } else {
        state.data.push(action.payload);
        storeInLocalStorage(state.data);
      }
      // Was logEvent(analytics, ` ${key} added to cart `) — the product name as
      // the *event name*, which GA4 rejects (spaces, >40 chars) and which made
      // every product its own event type instead of one countable add_to_cart.
      // Fired here rather than in the components so every dispatch path counts.
      trackAddToCart(action.payload);
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const itemToUpdate = state.data.find((item) => item.id === id);

      if (itemToUpdate) {
        const validQuantity = Math.max(quantity || 1, 1);
        itemToUpdate.quantity = validQuantity;
        itemToUpdate.totalPrice = itemToUpdate.price * validQuantity;
        // Persist like the other reducers do, so quantity changes survive a reload.
        storeInLocalStorage(state.data);
      }
    },

    removeItem(state, action) {
      const tempCart = state.data.filter(
        (item) => item.id !== action.payload.id
      );
      state.data = tempCart;
      storeInLocalStorage(state.data);
    },
    clearCart(state, action) {
      state.data =[] 
      storeInLocalStorage(state.data);
    },
    getCartTotal(state) {
      state.totalAmounts = state.data.reduce((cartTotal, cartItem) => {
        return (cartTotal += cartItem.totalPrice);
      }, 0);
      state.totalItems = state.data.length;
    },
    storeAccessToken(state,action){
      storeTokenInLocalStorage(action.payload)
    },
    fetchAccessToken(){
      const token=localStorage.getItem("token")
      return token
    }

  },
});

export const { addToCart, removeItem, getCartTotal, updateQuantity,storeAccessToken,fetchAccessToken,clearCart } =
  cartSlice.actions;
export default cartSlice.reducer;
